/**
 * Blog lead magnet — popup show trigger + form submit handler.
 *
 * Show conditions:
 *   - On blog post `/rasy-psow/*` (overlay markup już rendered by PHP)
 *   - Triggered po 30s OR 50% scroll, whichever first
 *   - Dismissed cookie `hn_blog_lm_dismissed` (30d) — skip show jeśli set
 *
 * Form submit → POST /wp-json/hn/v1/blog-lead-magnet → success: pokaż PDF link.
 *
 * POMIAR (dataLayer → wymaga triggera w GTM dla KAZDEGO zdarzenia):
 *   hn_blog_lm_missing    — jestesmy na /rasy-psow/*, ale markup popupu nie istnieje
 *   hn_blog_lm_suppressed — popup pominiety przez cookie (dismissed | optin)
 *   hn_blog_lm_shown      — popup wyswietlony  ← MIANOWNIK, bez niego nie ma CTR
 *   hn_blog_lm_dismissed  — zamkniety bez zapisu
 *   hn_blog_lm_submit     — formularz wyslany (proba)
 *   hn_blog_lm_error      — backend odrzucil zapis
 *   hn_blog_lead_magnet_optin — sukces (nazwa historyczna, nie zmieniac)
 */
const HN_LM_BREED_RE = /^\/rasy-psow\/([^/]+)\/?/;

function hnLmBreedFromPath() {
    const m = HN_LM_BREED_RE.exec(window.location.pathname);
    return m ? m[1] : '';
}

function hnLmTrack(event, extra) {
    if (!window.dataLayer) return;
    window.dataLayer.push(Object.assign({ event, breed_slug: hnLmBreedFromPath() }, extra || {}));
}

export function initBlogLeadMagnet() {
    const overlay = document.querySelector('[data-hn-blog-lm-overlay]');
    if (!overlay) {
        // Najczestsza hipoteza przy zerowej liczbie zapisow: popup w ogole sie nie renderuje.
        // Raportujemy to tylko na stronach ras, zeby nie zasmiecac reszty serwisu.
        if (hnLmBreedFromPath()) hnLmTrack('hn_blog_lm_missing');
        return;
    }

    // Skip jeśli user już dismiss lub opt-in (cookie).
    if (document.cookie.includes('hn_blog_lm_dismissed=1')) {
        hnLmTrack('hn_blog_lm_suppressed', { reason: 'dismissed' });
        return;
    }
    if (document.cookie.includes('hn_blog_lm_optin=1')) {
        hnLmTrack('hn_blog_lm_suppressed', { reason: 'optin' });
        return;
    }

    let shown = false;
    const show = (trigger) => {
        if (shown) return;
        shown = true;
        overlay.classList.add('is-visible');
        hnLmTrack('hn_blog_lm_shown', { trigger });
        // Focus trap entry — focus email input.
        const emailInput = overlay.querySelector('input[type="email"]');
        if (emailInput) setTimeout(() => emailInput.focus(), 100);
    };

    // Trigger 1: 30s delay
    const timeoutId = setTimeout(() => show('timer_30s'), 30000);

    // Trigger 2: 50% scroll
    const scrollHandler = () => {
        const scrollPct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
        if (scrollPct >= 0.5) {
            show('scroll_50');
            window.removeEventListener('scroll', scrollHandler);
        }
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });

    // Close handlers
    const close = (how) => {
        // Liczymy tylko zamkniecie faktycznie widocznego popupu — inaczej Escape
        // wcisniety przed pokazaniem zawyzalby liczbe odrzucen.
        if (shown) hnLmTrack('hn_blog_lm_dismissed', { how });
        overlay.classList.remove('is-visible');
        document.cookie = 'hn_blog_lm_dismissed=1; max-age=' + (30 * 24 * 60 * 60) + '; path=/; SameSite=Lax';
        clearTimeout(timeoutId);
        window.removeEventListener('scroll', scrollHandler);
    };
    overlay.querySelector('[data-hn-blog-lm-close]')?.addEventListener('click', () => close('button'));
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) close('backdrop'); // klik w backdrop
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && overlay.classList.contains('is-visible')) close('escape');
    });

    // Form submit
    const form = overlay.querySelector('[data-hn-blog-lm-form]');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const submitBtn = form.querySelector('[data-hn-blog-lm-submit]');
        const errorEl = form.querySelector('[data-hn-blog-lm-error]');
        const data = new FormData(form);
        const payload = {
            email: data.get('email'),
            breed_slug: data.get('breed_slug') || '',
            consent: data.get('consent') === 'on',
            nonce: data.get('nonce'),
        };

        hnLmTrack('hn_blog_lm_submit');
        submitBtn.disabled = true;
        submitBtn.textContent = 'Wysyłanie...';
        errorEl.hidden = true;

        try {
            const restUrl = (window.wpApiSettings?.root || '/wp-json/') + 'hn/v1/blog-lead-magnet';
            const resp = await fetch(restUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const result = await resp.json();
            if (!resp.ok || !result.success) {
                throw new Error(result.error || 'Wystąpił błąd. Spróbuj ponownie za chwilę.');
            }

            // Success state
            form.closest('[data-hn-blog-lm-step="form"]').hidden = true;
            const successEl = overlay.querySelector('[data-hn-blog-lm-step="success"]');
            successEl.hidden = false;
            const pdfLink = successEl.querySelector('[data-hn-blog-lm-pdf-link]');
            if (pdfLink && result.pdf_url) pdfLink.href = result.pdf_url;

            document.cookie = 'hn_blog_lm_optin=1; max-age=' + (365 * 24 * 60 * 60) + '; path=/; SameSite=Lax';

            // GA4 event (jeśli dataLayer dostępny)
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'hn_blog_lead_magnet_optin',
                    breed_slug: payload.breed_slug,
                });
            }
        } catch (err) {
            // Zero zapisow moze oznaczac zepsuty endpoint, a nie brak zainteresowania.
            hnLmTrack('hn_blog_lm_error', { message: String(err && err.message || err).slice(0, 120) });
            errorEl.textContent = err.message || 'Wystąpił błąd. Spróbuj ponownie za chwilę.';
            errorEl.hidden = false;
            submitBtn.disabled = false;
            submitBtn.textContent = 'Pobierz przewodnik';
        }
    });
}
